<template>
  <div class="navBar flex">
    <div
      class="cube flex"
      v-for="(item, index) in listBat"
      :key="index"
      @click="jump(item)"
    >
      <div class="circle_one flex-box">
        <img :src="item.img" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum" :style="{ color: item.color }">
          <span class="num">{{ item.value }}</span>
          <span class="ys">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getDpPagePanel } from "@/api/granary";
import { get } from "@/api/index";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "涉农企业数量",
          img: require("images/granary/nav/qy.png"),
          value: 0,
          color: "#FF9000",
          unit: "家",
        },
        {
          name: "耕地面积",
          img: require("images/granary/nav/gd.png"),
          // value: 226682.8,
          value: 226.68,
          color: "#00FFFF",
          // unit: "公顷"
          unit: "千公顷",
        },
        {
          name: "林地面积",
          img: require("images/granary/nav/ld.png"),
          value: 306844,
          color: "#E7F802",
          unit: "亩",
        },
        {
          name: "渔业面积",
          img: require("images/granary/nav/yy.png"),
          value: 37497.82,
          color: "#00FF73",
          unit: "公顷",
        },
        {
          name: "农业总产值",
          img: require("images/granary/nav/cz.png"),
          value: 5921381.21,
          color: "#00AEFF",
          unit: "万元",
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      get("/api/dp/visual/getDpDataItemByCode?pagePanelCode=headdata").then(
        (res) => {
          if (res) {
            this.listBat = res.map((ele) => {
              if (/涉农企业数量/.test(ele.item_name)) {
                ele.color = "#FF9000";
                ele.img = require("images/granary/nav/qy.png");
              } else if (/耕地面积/.test(ele.item_name)) {
                ele.color = "#00FFFF";
                ele.img = require("images/granary/nav/gd.png");
              } else if (/林地面积/.test(ele.item_name)) {
                ele.color = "#E7F802";
                ele.img = require("images/granary/nav/ld.png");
              } else if (/渔业面积/.test(ele.item_name)) {
                ele.color = "#00FF73";
                ele.img = require("images/granary/nav/yy.png");
              } else {
                ele.color = "#00AEFF";
                ele.img = require("images/granary/nav/cz.png");
              }
              return {
                name: ele.item_name,
                img: ele.img,
                value: ele.value,
                color: ele.color,
                unit: ele.unit,
              };
            });
          }
        }
      );

      // get("/api/restful/nyzl/headData").then(res => {
      //   console.log("nav1 res =", res);
      //   const data = res.data;
      //   if (data.length > 0) {
      //     this.listBat[0]["value"] = data[0]["value"];
      //     this.listBat[0]["unit"] = data[0]["unit"];
      //   }
      // });
      //toto 动态化
      //   getDpPagePanel("headdata").then(res => {
      //     this.listBat = res;
      //     this.listBat[0].img = require("images/granary/nav/qy.png");
      //     this.listBat[1].img = require("images/granary/nav/gd.png");
      //     this.listBat[2].img = require("images/granary/nav/ld.png");
      //     this.listBat[3].img = require("images/granary/nav/yy.png");
      //     this.listBat[4].img = require("images/granary/nav/cz.png");
      //     this.listBat[0].color = "#FF9000";
      //     this.listBat[1].color = "#00FFFF";
      //     this.listBat[2].color = "#E7F802";
      //     this.listBat[3].color = "#00FF73";
      //     this.listBat[4].color = "#00AEFF";
      //   });
    },
    jump(item) {
      if (item.name !== "涉农企业数量") return;
      window.open(window.__config.VUE_APP_IMG_URL + "/admin/qypp/org_company");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  background-color rgba(1,22,76 , 0.7)
  border-radius 4px
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
//   background url('~images/index/nav/navBg.png') center no-repeat
//   background-size 100% 100%
//   opacity .9
//   width 18%
  height 100%
  justify-content center

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem
  width 40px
  height 40px
//   background url('~images/granary/nav/nav-bg.png') no-repeat center
//   background-size 100% 100%

  img
    width 30px
    height 30px
    // vertical-align middle
</style>
